"use strict";

(function () {
  function dispatchThemeLoadingStart() {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );
  }

  function dispatchThemeLoadingEnd() {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true }),
    );
  }

  async function addVariantToCart(variantId, onSuccessDo, sourceElement) {
    const sectionsToBundle = [];

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    dispatchThemeLoadingStart();

    try {
      const formData = new FormData();
      formData.set("id", variantId);
      formData.set("quantity", "1");
      formData.set("on_success", onSuccessDo);
      formData.set("sections", sectionsToBundle.join(","));
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${variantId}`,
      );

      // window.themeCart (assets/poelle.js): the request with a time limit, that always answers
      const result = await window.themeCart.add(formData);
      const responseJson = result.json;

      if (!result.ok) {
        sourceElement.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson.description,
            },
          }),
        );

        if (result.failed) {
          // no answer from the server: say so on the card
          window.themeCart.showError(sourceElement, responseJson.description);
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }

        return;
      }

      const settings =
        (window.themeVariables && window.themeVariables.settings) || {};

      if (settings.cartType === "page" || settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cartContent = result.cart;

      if (!cartContent) {
        // added, but the cart could not be read back
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        return;
      }

      cartContent.sections = responseJson.sections;

      sourceElement.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items")
              ? responseJson.items
              : [responseJson],
            cart: cartContent,
            onSuccessDo,
          },
        }),
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo,
            cart: cartContent,
          },
        }),
      );
    } finally {
      dispatchThemeLoadingEnd();
    }
  }

  document.addEventListener(
    "click",
    async (event) => {
      const addButton = event.target.closest(".add-button");

      if (!addButton) {
        return;
      }

      const productCard = addButton.closest("product-card");

      if (!productCard) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (addButton.getAttribute("aria-busy") === "true") {
        return;
      }

      const available =
        productCard.getAttribute("data-product-available") === "true";

      if (!available) {
        const productUrl = productCard.getAttribute("data-product-url");

        if (productUrl) {
          window.location.href = productUrl;
        }

        return;
      }

      const nativeAddButton = productCard.querySelector(
        ".product-card__button",
      );

      if (nativeAddButton) {
        nativeAddButton.click();
        return;
      }

      const variantId = productCard.getAttribute("data-variant-id");

      if (!variantId) {
        const fallbackUrl = productCard.getAttribute("data-product-url");

        if (fallbackUrl) {
          window.location.href = fallbackUrl;
        }

        return;
      }

      addButton.setAttribute("aria-busy", "true");
      productCard.classList.add("is-adding");

      try {
        await addVariantToCart(
          variantId,
          productCard.getAttribute("data-on-success") || "force_open_drawer",
          productCard,
        );
      } finally {
        addButton.removeAttribute("aria-busy");
        productCard.classList.remove("is-adding");
      }
    },
    true,
  );
})();
